const enum PublicAppURL {
  android = "https://play.google.com/store/apps/details?id=com.equip.app",
  iOS = "https://apps.apple.com/us/app/equip-health/id1556174081",
}

export { PublicAppURL };
